const cards = [
  {
    tag: '娱乐圈',
    title: '某顶流男星深夜密会神秘女子，酒店同框照流出引热议',
    excerpt: '据知情人士透露，该男星近期与一名圈外女子频繁约会，多次被拍到深夜同返酒店。目前双方均未对此事做出回应，粉丝群体已出现大规模脱粉现象。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20moody%20night%20scene%20with%20luxury%20hotel%20entrance%20and%20mysterious%20atmosphere%2C%20warm%20amber%20street%20lights%2C%20cinematic%20editorial%20photography%20style%2C%20dramatic%20shadows%2C%20no%20people%20visible&width=600&height=400&seq=card-01-91hl&orientation=landscape',
    time: '2小时前',
    views: '128.6万',
  },
  {
    tag: '网红圈',
    title: '千万粉丝女主播直播间突然被封，背后原因令人唏嘘',
    excerpt: '该主播在昨晚的直播中因涉及敏感话题被平台紧急封禁，账号至今未恢复。据悉其此前已多次收到平台警告，此次封禁或与近期的一系列争议事件有关。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20streaming%20studio%20setup%20with%20ring%20light%20and%20monitors%2C%20moody%20crimson%20accent%20lighting%2C%20empty%20chair%20in%20front%20of%20camera%2C%20cinematic%20atmosphere%2C%20editorial%20style&width=600&height=400&seq=card-02-91hl&orientation=landscape',
    time: '5小时前',
    views: '96.3万',
  },
  {
    tag: '综艺',
    title: '热门综艺节目录制现场突发状况，导演组被指暗箱操作',
    excerpt: '某卫视王牌综艺最新一期录制中，现场观众爆料节目组存在严重造假行为，选手晋级结果疑似提前内定。多位现场观众在社交平台发文证实此事，引发广泛关注。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20TV%20studio%20set%20with%20dramatic%20stage%20lighting%2C%20empty%20stage%20with%20spotlights%2C%20mysterious%20backstage%20atmosphere%2C%20cinematic%20mood%20with%20crimson%20and%20gold%20accents&width=600&height=400&seq=card-03-91hl&orientation=landscape',
    time: '8小时前',
    views: '85.7万',
  },
  {
    tag: '社会',
    title: '知名企业家被曝涉嫌财务造假，公司股价应声暴跌',
    excerpt: '一份匿名举报材料在网络疯传，直指某知名上市公司创始人存在严重的财务违规行为。消息一出该公司股价单日暴跌超过30%，监管部门已介入调查。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20building%20at%20night%20with%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20glass%20facade%20reflecting%20city%20lights%2C%20cinematic%20editorial%20style&width=600&height=400&seq=card-04-91hl&orientation=landscape',
    time: '12小时前',
    views: '210.2万',
  },
  {
    tag: '娱乐圈',
    title: '某女星婚礼变闹剧，前男友携证据现场砸场子',
    excerpt: '昨日某知名女星在海外举办盛大婚礼，不料其前任男友突然现身并当众播放了多段私密视频，现场一度陷入混乱。婚礼被迫中断，双方亲友发生激烈冲突。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20wedding%20venue%20with%20warm%20decorations%2C%20empty%20ceremony%20setup%2C%20contrasting%20atmosphere%20of%20celebration%20and%20chaos%2C%20cinematic%20mood%2C%20editorial%20photography&width=600&height=400&seq=card-05-91hl&orientation=landscape',
    time: '1天前',
    views: '356.8万',
  },
  {
    tag: '品牌',
    title: '国际大牌代言人深陷丑闻，品牌方连夜解约发声明',
    excerpt: '某国际奢侈品牌中国区代言人近日被爆出严重负面新闻，品牌方在事件发酵仅6小时后便通过官方渠道宣布终止一切合作关系，创下品牌史上最快解约记录。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20brand%20billboard%20being%20removed%20at%20night%2C%20dramatic%20urban%20scene%2C%20moody%20atmosphere%20with%20city%20lights%2C%20cinematic%20editorial%20photography%20style&width=600&height=400&seq=card-06-91hl&orientation=landscape',
    time: '1天前',
    views: '189.4万',
  },
  {
    tag: '平台',
    title: '头部主播合约纠纷升级，平台与主播各执一词互不相让',
    excerpt: '某直播平台与旗下第一大主播的合约纠纷持续发酵，双方就分成比例和独家协议条款产生严重分歧。该主播已停播超过两周，大量粉丝发起维权活动要求平台放人。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20modern%20streaming%20platform%20headquarters%20at%20night%2C%20dramatic%20lighting%2C%20empty%20office%20with%20screens%2C%20mysterious%20corporate%20atmosphere%2C%20cinematic%20editorial%20style&width=600&height=400&seq=card-07-91hl&orientation=landscape',
    time: '2天前',
    views: '145.6万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            🔥 热门爆料
          </h2>
          <p className="text-sm text-foreground-600">
            全网最新最热的黑料爆料，每日实时更新，不错过任何劲爆内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.map((card, idx) => (
            <article
              key={idx}
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden bg-background-100">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-white">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}